<template>
	<div class="rentalservice">
		<div class="banner">
			<img src="~@/assets/image/cbanner.png">
			<div class="banner_txt">
				<div class="title">
					<div>更轻松的特装展台在线租赁平台</div>
					<div class="des">中小企业特装展台租赁解决方案</div>
					<div class="des">中小企业特装展台租赁解决方案</div>					
				</div>

			</div>
		</div>
		<div class="product_list">
			<div class="container">
				<div class="title_bar">
					<div class="title">展特易展台租赁方案</div>
					<div class="more">查看更多</div>
				</div>
				<div class="products">
					<div class="product_item">
						<div>
							<div class="title">租赁方案名称租赁方案名称租赁方案名称…</div>
							<div class="price">¥5k-20k</div>
							<div class="look">立即查看！</div>
						</div>
						<div>
							<img src="~@/assets/image/pro.png">
						</div>
					</div>
					
					<div class="product_item">
						<div class="product_info">
							<div class="title">租赁方案名称租赁方案名称租赁方案名称…</div>
							<div class="price">¥5k-20k</div>
							<div class="look">立即查看！</div>
						</div>
						<div>
							<img src="~@/assets/image/pro.png">
						</div>
					</div>					

					<div class="product_item">
						<div class="product_info">
							<div class="title">租赁方案名称租赁方案名称租赁方案名称…</div>
							<div class="price">¥5k-20k</div>
							<div class="look">立即查看！</div>
						</div>
						<div class="pro_img">
							<img src="~@/assets/image/pro.png">
						</div>
					</div>
					<div class="product_item">
						<div class="product_info">
							<div class="title">租赁方案名称租赁方案名称租赁方案名称…</div>
							<div class="price">¥5k-20k</div>
							<div class="look">立即查看！</div>
						</div>
						<div>
							<img src="~@/assets/image/pro.png">
						</div>
					</div>
					
					<div class="product_item">
						<div class="product_info">
							<div class="title">租赁方案名称租赁方案名称租赁方案名称…</div>
							<div class="price">¥5k-20k</div>
							<div class="look">立即查看！</div>
						</div>
						<div>
							<img src="~@/assets/image/pro.png">
						</div>
					</div>					

					<div class="product_item">
						<div class="product_info">
							<div class="title">租赁方案名称租赁方案名称租赁方案名称…</div>
							<div class="price">¥5k-20k</div>
							<div class="look">立即查看！</div>
						</div>
						<div class="pro_img">
							<img src="~@/assets/image/pro.png">
						</div>
					</div>					
				</div>
			</div>
		</div>

		<div class="row_ad">
			<div class="container">
				<div class="zq_left">
					<div class="title">展特易展台<span>定制优势</span></div>
					<div class="ad_row_list">
						<div class="step">
							步骤一：<span>租赁方案选择</span>
						</div>
						<div class="step_txt">平台提供标准租赁套餐方案选择 / 选择定制展台方案进行租赁。</div>


					</div>
				</div>
				<div class="zq_right">
					<img src="~@/assets/image/advantage.png">
				</div>
			</div>
			<div class="zq_right_cover">
				<div class="swiper-container ad_row_right">
					<div class="swiper-wrapper">
						<div class="swiper-slide">
							<img src="~@/assets/image/adlist.png" />
						</div>
						<div class="swiper-slide"><img src="~@/assets/image/adlist.png" /></div>
						<div class="swiper-slide"><img src="~@/assets/image/adlist.png" /></div>
					</div>
					<div class="swiper-button-prev"></div>
					<div class="swiper-pagination"></div>
					<div class="swiper-button-next"></div>
				</div>
			</div>
		</div>
		<CForm></CForm>
	</div>
</template>

<script>
	import CForm from '@/components/zqtool/CForm.vue';
	export default {
		name: "CustomizedService",
		components: {
			CForm
		},
		props: {},
		data() {
			return {};
		},
		watch: {},
		computed: {},
		methods: {},
		created() {},
		mounted() {
			this.$nextTick(function() {
				let galleryTop = new Swiper('.ad_row_right', {
					nextButton: '.swiper-button-next',
					prevButton: '.swiper-button-prev',
					spaceBetween: 80,
					slidesPerView: "auto",
					loop: true,
					pagination: '.swiper-pagination',
					paginationType: 'custom',
					paginationCustomRender: function(swiper, current, total) {
						return "<div class='custompagination'><div class='cur'>" + current + "</div>" +
							'<div class="pagination_txt">/</div>' + '<div class="pagination_txt">' +
							total + '</div></div>';
					}
				});

			})
		}
	};	
</script>

<style lang="scss" scoped>
	@import "@/assets/css/rentalservice.scss";
</style>